import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getVehiculos = async () => {
  const respuesta = await PrivateInterceptor(`Global/Vehiculos`, "GET");
  return respuesta;
};

export const GuardarVehiculo = (Datos) => {
  const respuesta = PrivateInterceptor("Global/Vehiculos/GuardarVehiculo", "POST", {Datos});
  return respuesta;
};

export const EditarVehiculo = (Datos) => {
  const respuesta = PrivateInterceptor("Global/Vehiculos/EditarVehiculo", "POST", {Datos});
  return respuesta;
};

export const getColores = async () => {
  const respuesta = await PrivateInterceptor(`Global/Vehiculos/Colores`, "GET");
  return respuesta;
};

export const getManoObra = async () => {
  const respuesta = await PrivateInterceptor(`Global/getManoObra`, "GET");
  return respuesta;
};
